module.exports = __webpack_public_path__ + "static/media/casino_holdem.netent.80c399e1.jpeg";